module.exports = __webpack_public_path__ + "img/wardInfoRed.9666b703.svg";